import { UserDetails, PermissionRoute } from '@anytag/app';
import { advertiserRoles } from '@anytag/shared-constants';
import { PartialRouter } from '../../types';

export const UserSettingsRouter = {
  '/_private-routes/user-settings': [
    () => <PermissionRoute permissions={advertiserRoles} element={<UserDetails isUserSettingsForAdvertisers />} />,
    {}
  ]
} as const satisfies PartialRouter;
